import { InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";
import { cognitoClient } from "./cognito-client";

export const login = async (username, password) => {
  const clientId = process.env.REACT_APP_CLIENT_ID;
  
  const command = new InitiateAuthCommand({
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    }
  });

  return await cognitoClient.send(command);
};
